import BotaoContato from "../../componentes/BotaoContato/BotaoContato.js";
import "./QuemSomos.css";

function QuemSomos() {
  return (
    <section className="container py-5" aria-label="Seção Quem Somos" id="section-quem-somos">
      <div className="row g-4">
        <div className="col-12 col-lg-6 col-xl-6  scroll-reveal-glass">
          <h2 className="mb-3 titulo-secao quem-somos text-md-start ">
            Quem Somos
            <span className="barra quem-somos"></span>
          </h2>
          <p>
            A ÂMBAR nasceu do encontro de três engenheiras determinadas a
            transformar a forma como se faz consultoria ambiental e engenharia.
            Em um setor técnico, muitas vezes rígido e pouco sensível às nuances
            ambientais, criamos uma empresa que une conhecimento especializado,
            responsabilidade socioambiental e visão estratégica.
          </p>
          <p>
            Mais do que cumprir normas, queremos redefinir a relação entre
            empreendimentos e meio ambiente, oferecendo soluções técnicas,
            sustentáveis e personalizadas — sempre com foco em resultados
            efetivos e no desenvolvimento responsável.
          </p>
          <div className="d-none d-md-block mt-4 mb-4">
            <BotaoContato texto="Saiba mais sobre a Âmbar" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre os serviços da Âmbar" />
          </div>
        </div>

        <div className="col-12 col-lg-6 d-md-flex align-items-md-center m-md-0">
          <div className="ratio ratio-16x9 mt-lg-4 scroll-reveal-glass">
            <iframe
              src="https://www.youtube.com/embed/CaaEX8aEldY?autoplay=1&mute=1&controls=1&rel=0"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="rounded-2"
            ></iframe>
          </div>

          <div className="mt-4 d-md-none">
            <BotaoContato texto="Saiba mais sobre a Âmbar" rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre os serviços da Âmbar" />
          </div>
        </div>
      </div>
    </section>
    //  <section className="quem-somos-wrapper container py-5 scroll-reveal" aria-label="Seção Quem Somos">
    //   <div className="row justify-content-center">
    //     <div className="col-12 col-lg-12 text-center">
    //       <h2 className="mb-3 titulo-secao scroll-reveal-zoom">
    //         Quem Somos <span className="barra"></span>
    //       </h2>
    //       <p className="scroll-reveal-zoom">
    //         A ÂMBAR nasceu do encontro de três engenheiras determinadas a
    //         transformar a forma como se faz consultoria ambiental e engenharia.
    //         Em um setor técnico, muitas vezes rígido e pouco sensível às nuances
    //         ambientais, criamos uma empresa que une conhecimento especializado,
    //         responsabilidade socioambiental e visão estratégica.
    //       </p>
    //       <p className="scroll-reveal-zoom">
    //         Mais do que cumprir normas, queremos redefinir a relação entre
    //         empreendimentos e meio ambiente, oferecendo soluções técnicas,
    //         sustentáveis e personalizadas — sempre com foco em resultados
    //         efetivos e no desenvolvimento responsável.
    //       </p>
    //       <div className="ratio ratio-21x9 mb-4 scroll-reveal-glass">
    //         <iframe src="https://www.youtube.com/embed/SEU_VIDEO_ID" title="Âmbar Soluções em Engenharia e Meio Ambiente" allowFullScreen ></iframe>
    //       </div>
    //       <div className="scroll-reveal-zoom">
    //         <BotaoContato texto="Saiba mais sobre a Âmbar" rota="/" />
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
}

export default QuemSomos;
